<template>
    <div>
        <kt-nav space="md" size="lg" id="kt-nav">
            <form @submit.prevent="changeSheba" id="changeSehba_form">
                <kt-nav-item>
                    <div id="changeSheba">
                        <div class="card" style="overflow:inherit">
                            <div class="card-header bg-white" id="headingOne">
                                <div class="card-title"
                                     data-target="#shebaForm"
                                     aria-controls="shebaForm">
                                    <i class="fa fa-credit-card"></i>
                                    {{ $t('panel.shaparak-requests.change-sheba') }}
                                </div>
                            </div>

                            <div
                                id="shebaForm"
                                aria-labelledby="shebaForm"
                                data-parent="#changeSheba"
                                v-if="form_data.status === gatewayStatus.ACTIVE || form_data.status === gatewayStatus.REJECTED_BY_SHAPARAK"
                            >
                                <div class="card-body bg-white">
                                    <kt-form-section>
                                        <kt-form-row>
                                            <kt-col xs="12" :md="show_main_settlement_iban ? '6' : '12'">
                                                <kt-form-group>
                                                    <kt-form-label for="sheba_number">
                                                        {{ $t('label.sheba_number') }}
                                                    </kt-form-label>

                                                    <div id="sheba-number-selector-container">
                                                        <select
                                                            id="sheba_number"
                                                            name="sheba_id"
                                                            v-model="form_data.sheba"
                                                                class="form-control kt-selectpicker text-secondary"
                                                            data-live-search="true"
                                                                data-style="btn-outline-secondary"
                                                            multiple
                                                            size="6"
                                                        >
                                                            <option
                                                                v-for="sheba_number in all_sheba_numbers"
                                                                :key="sheba_number.id"
                                                                :value="sheba_number.id"
                                                            >
                                                                {{ sheba_number.number }}
                                                            </option>
                                                        </select>

                                                        <small class="text-muted d-block mt-2" v-if="is_direct_settlement">
                                                            (یک شبا را انتخاب کنید تا برای این درگاه فعال شود)
                                                        </small>
                                                        <small class="text-muted d-block mt-2" v-else>
                                                            (لیست همه شباها؛ موارد انتخاب‌شده برای این درگاه فعال می‌شوند)
                                                        </small>

                                                        <!-- <div class="mt-4">
                                                            <div class="d-flex align-items-center mb-2">
                                                                <span class="font-weight-bold">سایر شباها</span>
                                                                <small class="text-muted mr-2">(انتخاب‌نشده‌ها)</small>
                                                            </div>
                                                            <div class="border rounded p-2 bg-transparent" style="max-height: 160px; overflow:auto;">
                                                                <span
                                                                    v-for="sheba in other_sheba_numbers"
                                                                    :key="sheba.id"
                                                                    class="badge badge-light border m-1 en_num"
                                                                    style="font-size: 90%;"
                                                                >
                                                                    {{ sheba.number }}
                                                                </span>
                                                                <div v-if="other_sheba_numbers.length === 0" class="text-muted small">
                                                                    موردی برای نمایش نیست.
                                                                </div>
                                                            </div>
                                                        </div> -->
                                                    </div>
                                                </kt-form-group>
                                            </kt-col>

                                            <kt-col xs="12" md="6" v-if="show_main_settlement_iban">
                                                <kt-form-group>
                                                    <kt-form-label for="main_settlement_iban">
                                                        {{ $t('label.main_iban_sheba') }}
                                                    </kt-form-label>

                                                    <div id="main-settlement-iban-selector-container">
                                                        <select
                                                            id="main_settlement_iban"
                                                            name="main_settlement_iban"
                                                            v-model="form_data.main_settlement_iban"
                                                            class="form-control kt-selectpicker"
                                                        >
                                                            <option value="" disabled>انتخاب شبای اصلی</option>
                                                            <option
                                                                v-for="sheba_number in selected_sheba_numbers"
                                                                :key="sheba_number.id"
                                                                :value="sheba_number.id"
                                                                class="en_num"
                                                            >
                                                                {{ sheba_number.number }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </kt-form-group>
                                            </kt-col>
                                        </kt-form-row>
                                    </kt-form-section>

                                    <kt-form-section>
                                        <button class="btn btn-success btn-wide" id="changeSheba_btn">
                                            {{ $t('label.send_request') }}
                                        </button>
                                    </kt-form-section>
                                </div>
                            </div>
                        </div>
                    </div>
                </kt-nav-item>
            </form>
        </kt-nav>

        <kt-datatable v-bind="datatableProps" ref="datatable" class="bg-white"></kt-datatable>
    </div>
</template>

<script>
import $ from "jquery";
import columns from "../datatable/change-requests-columns";
import { mapGetters } from "vuex";
import { ApiUrl } from "@/common/api.service";
import { AuthorizationHeader } from "@/common/jwt.service";
import { i18n } from "@/plugins/i18n";
import { gatewayStatus } from "../../../constants/gatewayStatus";
import { gatewayService } from "@/common/api.service";
import { shebaNumberService } from "@/common/core.service";
import {shopType} from "@/constants/ShopType";
import { KTApp } from "@/plugins/core/app";

export default {
    props: {
        form_data: {
            type: Object,
            default() {
                return {};
            }
        },
    },

    data() {
        return {
            gatewayStatus,
            query: {},
            all_sheba_numbers: [],
            other_sheba_numbers: [],
            shopType
        };
    },

    computed: {
        hashid() {
            return this.$route.params.hashid;
        },

        // direct (psp) gateways settle to a single sheba; payment_helper may have several
        is_direct_settlement() {
            return (
                Number(this.form_data.type) === shopType.BUSINESS_PSP_SETTLEMENT
            );
        },

        show_main_settlement_iban() {
            return this.form_data.status === gatewayStatus.REJECTED_BY_SHAPARAK && !this.is_direct_settlement;
        },

        max_sheba_options() {
            return this.is_direct_settlement ? 1 : false;
        },

        selected_sheba_numbers() {
            const selected_ids = Array.isArray(this.form_data.sheba) ? this.form_data.sheba : [];
            return this.all_sheba_numbers.filter((sheba_number) =>
                selected_ids.includes(sheba_number.id)
            );
        },

        datatableProps() {
            if (!this.hashid) {
                return {
                    id: "shaparak_requests_datatable",
                    data: {
                        type: "remote",
                        source: {
                            read: {
                                url: "",
                                method: "GET",
                                headers: AuthorizationHeader,
                                map: () => [],
                            },
                        },
                        pageSize: 15,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    pagination: false,
                    sortable: true,
                    columns,
                };
            }

            return {
                id: "shaparak_requests_datatable",
                data: {
                    type: "remote",
                    source: {
                        read: {
                            url: ApiUrl.path(`shaparak/user-change-requests/${this.hashid}`),
                            method: "GET",
                            headers: AuthorizationHeader,
                            map: (res) => res.data.data,
                            params: { query: this.query },
                        },
                    },
                    pageSize: 15,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns,
            };
        },

        ...mapGetters("gateway", {
            gateway: "form_data",
            status: "status",
        }),
    },

    methods: {
        initializeSelectpicker() {
            this.$nextTick(() => {
                $(".kt-selectpicker").selectpicker({
                    size: 6,
                    liveSearch: true,
                    noneResultsText: i18n.t("selectpicker.none_result"),
                    selectAllText: i18n.t("selectpicker.select_all"),
                    noneSelectedText: i18n.t("selectpicker.nothing_selected"),
                });
                $("#sheba_number").selectpicker({
                    maxOptions: this.max_sheba_options,
                });
                $(".kt-selectpicker").selectpicker("refresh");
            });
        },

        computeOtherShebas() {
            const selectedIds = new Set(this.form_data.sheba || []);
            this.other_sheba_numbers = this.all_sheba_numbers.filter(
                (s) => !selectedIds.has(s.id)
            );
        },

        renderMainSettlementIbanPicker() {
            this.$nextTick(() => {
                const $select = $("#main_settlement_iban");
                if (!$select.length) return;

                if ($select.data("selectpicker")) {
                    $select.selectpicker("refresh");
                } else {
                    $select.selectpicker({ size: 5 });
                }
            });
        },

        async loadShebas() {
            if (!this.hashid) return;
        
            try {
                const [allRes, gatewayRes] = await Promise.all([
                    shebaNumberService.fetch(),
                    gatewayService.getGatewayShebaNumbers(this.hashid),
                ]);
            
                this.all_sheba_numbers =
                    allRes && allRes.data && allRes.data.data ? allRes.data.data : [];
            
                let selected = [];
                if (
                    gatewayRes &&
                    gatewayRes.data &&
                    gatewayRes.data.data &&
                    gatewayRes.data.data.sheba_numbers
                ) {
                    selected = gatewayRes.data.data.sheba_numbers;
                }
            
                const selectedIds = selected.map((s) => s.id);
            
                if (!Array.isArray(this.form_data.sheba)) {
                    this.$set(this.form_data, "sheba", []);
                }

                this.form_data.sheba = selectedIds;

                this.computeOtherShebas();
                this.initializeSelectpicker();
                this.renderMainSettlementIbanPicker();
            } catch (err) {
                console.error("Error loading shebas:", err);
            } finally {
                this.$nextTick(() => $(".kt-selectpicker").selectpicker("refresh"));
            }
        },


        changeSheba() {
            $("#sheba_error_msg").remove();
            $("#main_settlement_iban_error_msg").remove();
            if (!this.hashid) return;

            const form = $("#changeSehba_form");
            const btn = $("#changeSheba_btn");
            const nav = $("#kt-nav");

            form.validate({
                rules: {
                    sheba_number: { required: true },
                },
            });

            if (!form.valid()) return;

            const selected_sheba_ids = Array.isArray(this.form_data.sheba) ? this.form_data.sheba : [];

            const is_rejected_by_shaparak = this.form_data.status === gatewayStatus.REJECTED_BY_SHAPARAK;

            if (is_rejected_by_shaparak && this.show_main_settlement_iban && !this.form_data.main_settlement_iban) {
                $("#main-settlement-iban-selector-container").append(
                    `<span id="main_settlement_iban_error_msg" class="small text-danger d-block mt-1">${i18n.t("label.select_main_settlement_iban")}</span>`
                );
                return;
            }

            if (this.is_direct_settlement && selected_sheba_ids.length !== 1) {
                $("#sheba-number-selector-container").append(
                    `<span id="sheba_error_msg" class="small text-danger d-block mt-1">${i18n.t("label.select_only_one_sheba")}</span>`
                );
                return;
            }

            const params = {
                sheba_id: this.form_data.sheba,
                shop_id: this.hashid,
            };

            if (is_rejected_by_shaparak) {
                params.main_settlement_iban = this.show_main_settlement_iban
                    ? this.form_data.main_settlement_iban
                    : params.sheba_id[0];
            }

            const original_btn_html = btn.html();
            KTApp.progress(btn);
            btn.text(i18n.t("btn.please_wait"));

            gatewayService.userChangeShebaRequest(params)
                .then((response) => {
                    this.showMsg(nav, "success", response.data.message);
                    if (this.form_data.status === gatewayStatus.REJECTED_BY_SHAPARAK) {
                        this.form_data.status = gatewayStatus.PENDING;
                    }
                    // this.$refs.datatable.reload();
                })
                .catch((error) => {
                    const response = error.response;

                    if (response && response.data && response.data.data) {
                        const errors = response.data.data;
                        if (errors.sheba_id) {
                          $("#sheba_error_msg").remove();

                          const errorMsg = Array.isArray(errors.sheba_id)
                              ? errors.sheba_id[0]
                              : errors.sheba_id;

                          $("#sheba-number-selector-container").append(`<span id="sheba_error_msg" class="small text-danger d-block mt-1">${errorMsg}</span>`);
                        }

                        if (errors.main_settlement_iban) {
                          $("#main_settlement_iban_error_msg").remove();

                          const errorMsg = Array.isArray(errors.main_settlement_iban)
                              ? errors.main_settlement_iban[0]
                              : errors.main_settlement_iban;

                          $("#main-settlement-iban-selector-container").append(`<span id="main_settlement_iban_error_msg" class="small text-danger d-block mt-1">${errorMsg}</span>`);
                        }
                    }

                    if (response && response.data && response.data.message) {
                        this.showMsg(nav, "danger", response.data.message);
                    } else {
                        this.showMsg(nav, "danger", "خطایی رخ داده است.");
                    }
                })
                .finally(() => {
                    KTApp.unprogress(btn);
                    btn.html(original_btn_html);
                });
        },
    },

    mounted() {
        this.loadShebas();
    },

    watch: {
        "$route.params.hashid"(newHashid, oldHashid) {
            if (newHashid && newHashid !== oldHashid && this.$refs.datatable) {
                this.$nextTick(() => this.$refs.datatable.reload());
                this.loadShebas();
            }
        },
        "form_data.sheba"(val) {
            this.$nextTick(() => $(".kt-selectpicker").selectpicker("refresh"));
            this.computeOtherShebas();

            const selected_ids = Array.isArray(val) ? val : [];
            if (!selected_ids.includes(this.form_data.main_settlement_iban)) {
                this.form_data.main_settlement_iban = selected_ids.length === 1 ? selected_ids[0] : null;
            }
        },

        selected_sheba_numbers() {
            this.renderMainSettlementIbanPicker();
        },
    },
};
</script>
